import "antd/dist/antd.css";
import React, { useCallback } from "react";
import axios from "@/utils/myAxios";
import { PageHeader, Dropdown, Menu, Icon, Modal, Tag, Row, Col, Form, Input, message, } from "antd";
import { Link } from "react-router-dom";
import locales from "@/locales/index";
import { tableSummaries, isMobileDevice } from '@/utils/utils'
import { RSA } from '@/utils/rsa'
import moment from "moment";
import Cookie from "js-cookie";
let timer

// 表单数据
const formData = {
    oldPassword: undefined,
    newPassword: undefined,
    confrimPassword: undefined,
}

export default class Header extends React.Component {
    state = {
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        show: false, // 是否显示弹窗
        formData: { ...formData }, // 表单数据
        serverDateInfo: {}, // 服务器日期
    };

    componentDidMount () {
        this.fetchServerDateInfo();
        setInterval(() => {
            clearInterval(timer)
            this.fetchServerDateInfo();
        }, 60000 * 6)
    }

    /**
     * 获取服务器日期
     */
    fetchServerDateInfo = () => {
        axios
            .get("/v1/api/server_time")
            .then((res) => {
                // 实时更新时间
                let timestamp = res.data.ts * 1000
                if (!timestamp) return
                const formatDate = () => {
                    let realDate = moment
                        .utc(timestamp)
                        .utcOffset(8)
                        .format("UTC+8 YYYY-MM-DD HH:mm:ss");
                    this.setState({
                        serverDateInfo: {
                            ...res.data,
                            realDate
                        },
                    });
                }

                formatDate()
                timer = setInterval(() => {
                    timestamp += 1000
                    formatDate()
                }, 1000)
            });
    };

    /**
     * 显示菜单
     */
    handleShowMenu () {
        window.dispatchEvent(new CustomEvent('showMenu', {
            detail: true,
        }));
    }

    /**
     * 退出登录
     */
    handleLogout = (showConfirm = true) => {
        const callback = () => {
            axios.patch("/v1/api/union_logout").then((res) => {
                if (res.code === 1) {
                    Object.keys(Cookie.get()).forEach((item) => {
                        Cookie.remove(item);
                    });
                    window.location.href = "/";
                }
            });
        }

        if (showConfirm) {
            Modal.confirm({
                title: this.props.language["hint"],
                content: this.props.language["logoutConfirm"],
                onOk: () => {
                    callback()
                },
            });
        } else {
            callback()
        }
    };

    /**
     * 提交表单
     */
    handleSubmit = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.state.type === "changePassword") {
                    // 修改密码
                    Modal.confirm({
                        title: this.props.language["hint"],
                        content: this.props.language["editConfirm"],
                        onOk: () => {
                            axios
                                .get("/v1/api/kpoker_union/time")
                                .then((res) => {
                                    if (res.code === 1) {
                                        axios
                                            .patch("/v1/api/kpoker_union/set_new_password", {
                                                passwd: RSA.encrypt(values.oldPassword + '\b' + res.data),
                                                new_passwd: RSA.encrypt(values.newPassword + '\b' + res.data),
                                            })
                                            .then((res) => {
                                                if (res.code === 1) {
                                                    message.success(this.props.language["changePasswordSuccess"]);
                                                    this.handleClose();
                                                    setTimeout(() => {
                                                        this.handleLogout(false);
                                                    }, 1500)
                                                }
                                            });
                                    }
                                });
                        },
                    });
                }
            }
        });
    };

    /**
     * 显示弹窗
     */
    handleShow = (type) => {
        let title;
        switch (type) {
            case "changePassword":
                title = this.props.language["changePassword"];
                break;
        }
        this.setState({
            show: true,
            type,
            title,
        });
    };

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields();
        this.setState({ show: false, formData: { ...formData } });
    };

    render () {
        const identityTypeName = Cookie.get("identityTypeName")
        const identityType = Cookie.get("identityType")
        const accountType = Cookie.get("accountType")

        return (
            <div className="header-container">
                {/* 菜单icon */}
                <Icon className="menu-icon mr10" onClick={this.handleShowMenu}
                    type="menu-unfold"
                    style={{ fontSize: 25 }}
                />

                <Row type="flex" align="middle" justify="space-between" style={{ width: '100%' }}>
                    {/* 左侧区域 */}
                    <Col>
                        <span className="fs14">{this.props.language["serverDate"]}：{this.state.serverDateInfo.realDate}</span>
                    </Col>

                    {/* 右侧区域 */}
                    <Col>
                        <Row type="flex" align="middle">
                            {/* 切换语言 */}
                            <Dropdown trigger={['click']} className='mr10'
                                overlay={
                                    <Menu selectedKeys={[this.props.languageName]}>
                                        {Object.values(locales).map((item) =>
                                            <Menu.Item key={item.value} onClick={() => this.props.languageChange(item.value)}>{item.label}</Menu.Item>
                                        )}
                                    </Menu>
                                }
                            >
                                <Row type="flex" align="middle" style={{ cursor: "pointer" }}>
                                    <svg t="1749107430852" className="icon mr5" viewBox="0 0 1040 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10303" width="18" height="18"><path d="M621.714 402.286H950.86c40.41 0 73.142 32.548 73.142 73.142V950.86C1024 991.268 991.452 1024 950.858 1024H475.428c-40.41 0-73.142-32.548-73.142-73.142V621.714H73.14C32.732 621.714 0 589.166 0 548.572V73.14C0 32.732 32.548 0 73.142 0h475.43c40.41 0 73.142 32.548 73.142 73.142v329.144z m0 73.142v73.144c0 40.41-32.548 73.142-73.142 73.142h-73.144v292.608c0 20.188 16.348 36.536 36.536 36.536h402.32c20.18 0 36.536-16.358 36.536-36.536V512c0-20.178-16.356-36.534-36.534-36.534H621.714v-0.038zM73.142 109.68V512c0 20.188 16.348 36.534 36.536 36.534H512A36.534 36.534 0 0 0 548.534 512V109.714a36.534 36.534 0 0 0-36.498-36.572H109.716A36.534 36.534 0 0 0 73.14 109.68z m73.144 279.186v-183.88h128.84V128h53.432c7.314 1.06 11.008 2.084 11.008 3.146a12.068 12.068 0 0 1-1.572 4.716c-3.146 8.376-4.72 18.324-4.72 29.844v39.276h136.742v179.164h-58.148V360.56h-78.592v135.168H276.7v-135.168H199.716v28.306H146.286z m53.394-139.85v69.12h77.02v-69.082H199.716l-0.036-0.038z m212.188 69.12v-69.082h-78.592v69.12h78.592v-0.038z m232.96 557.716H585.14l105.29-290.708h73.874l102.108 290.744h-62.83l-22.016-61.33h-114.724l-21.98 61.294h-0.036z m37.74-110.008h83.274l-39.278-124.124h-1.572l-42.422 124.124zM950.86 292.572h-73.144c0-80.792-65.494-146.286-146.286-146.286V73.14c121.188 0 219.43 98.242 219.43 219.43zM73.14 731.428h73.144c0 80.792 65.494 146.286 146.286 146.286v73.144c-121.188 0-219.43-98.242-219.43-219.43z" fill="#515151" p-id="10304"></path></svg>
                                    <span>{this.props.getLanguage('label')}</span>
                                </Row>
                            </Dropdown>

                            {/* 用户信息 */}
                            <span>{Cookie.get("name")}</span>
                            <span>({Cookie.get("account")})</span>
                            <Dropdown
                                trigger={['click']}
                                overlay={
                                    <Menu>
                                        {(identityType === "direct_union" || identityType === "direct_union_vip" || identityType === "kpoker_union" || identityType === "kpoker_union_vip" || accountType == 1) &&
                                            <Menu.Item onClick={() => this.handleShow('changePassword')}>
                                                <Icon className="mr10" type="edit" />
                                                {this.props.language["changePassword"]}
                                            </Menu.Item>
                                        }
                                        {(identityType === "super_union_vip" || identityType === "union_vip" || identityType === "direct_union_vip" || identityType === "kpoker_union_vip") && (
                                            <Menu.Item>
                                                <Link to="/account_switch">
                                                    <Icon className="mr10" type="swap" />
                                                    {this.props.language["switchAccount"]}
                                                </Link>
                                            </Menu.Item>
                                        )}
                                        <Menu.Item onClick={this.handleLogout}>
                                            <Icon className="mr10" type="logout" />
                                            {this.props.language["logout"]}
                                        </Menu.Item>
                                    </Menu>
                                }
                            >
                                <div style={{ cursor: "pointer" }}>
                                    <Tag className="ml10" color="#108ee9">
                                        {identityTypeName}
                                    </Tag>
                                    <Icon type="down" />
                                </div>
                            </Dropdown>
                        </Row>
                    </Col>
                </Row>

                {/* 表单弹窗 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    formData={this.state.formData}
                    onOk={this.handleSubmit}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />
            </div>
        );
    }
}

/**
 * 表单弹窗
 */
const FormModal = Form.create({ name: "form_model" })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator, getFieldValue } = this.props.form;
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: "auto",
                    }}
                >
                    <div className="container-content">
                        <Form>
                            {/* 修改密码 */}
                            {this.props.type === "changePassword" && (
                                <>
                                    <Form.Item label={this.props.language["oldPassword"]}>
                                        {getFieldDecorator("oldPassword", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["oldPasswordVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.oldPassword,
                                        })(
                                            <Input
                                                maxLength={60}
                                                allowClear
                                                placeholder={
                                                    this.props.language[
                                                    'oldPasswordPlaceholder'
                                                    ]
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item label={this.props.language["newPassword"]}>
                                        {getFieldDecorator("newPassword", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["newPasswordVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.newPassword,
                                        })(
                                            <Input
                                                maxLength={60}
                                                allowClear
                                                placeholder={
                                                    this.props.language[
                                                    'newPasswordPlaceholder'
                                                    ]
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item label={this.props.language["confrimPassword"]}>
                                        {getFieldDecorator("confrimPassword", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["confrimPasswordVerify"],
                                                },
                                                {
                                                    validator: (_, value, callback) => {
                                                        if (value && value !== getFieldValue('newPassword')) {
                                                            return callback(this.props.language["confrimPasswordVerify2"]);
                                                        }
                                                        return callback();
                                                    },
                                                },
                                            ],
                                            initialValue: this.props.formData.confrimPassword,
                                        })(
                                            <Input
                                                maxLength={60}
                                                allowClear
                                                placeholder={
                                                    this.props.language[
                                                    'confrimPasswordPlaceholder'
                                                    ]
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                </>
                            )}
                        </Form>
                    </div>
                </Modal>
            );
        }
    }
);

